import React from 'react';
import AboutMainWrap from "../style/wrap";
import Container from "../../../../components/paper/container";
import SectionTitle from "../../../../components/heading/section";
import {Button, Card, Col, Row, Space} from "antd";
import CardTitle from "../../../../components/heading/card";
import styled from "styled-components"
import {Icon} from '@iconify/react';
import AuthLayout from '../../../../layouts/auth.layout';
import P1 from "../../../../components/paragraph";

const AboutMain = () => {
    return (
        <AboutMainWrap>
            <Container>
                <Space direction='vertical' size={32} style={{width: '100%', paddingTop: '0px'}}>  
                    <Row gutter={[32, 32]}>
                        <Col lg={{span: 8}} span={AuthLayout}>
                            <Space direction='vertical' style={{width: '100%'}} size={32}>
                                <P1>
                                    <ul>
                                        <li><p><strong>No More Filling Out Applications</strong><br/>No more filling out rental applications. Simply share your rental profile with landlords to apply.</p></li>
                                        <li><p><strong>One Click Application Saves Time</strong><br/>One Click application saves time and money.</p></li>
                                        <li><p><strong>Digital Record Keeping</strong><br/>iCard maintains digital records of rental applications, leases, rent payments, maintenance records making tracking and monitoring of rent payments and service requests a breeze.</p></li>
                                      </ul> 
                                </P1>
                            </Space>
                        </Col>
                        <Col lg={{span: 8}} span={AuthLayout}>
                            <Space direction='vertical' style={{width: '100%'}} size={32}>
                                <P1>
                                    <ul>
                                        <li><p><strong>Save Money On Fees</strong><br/>iCard saves you hundreds in fees by reusing your verified profile over and over.</p></li>
                                        <li><p><strong>Online Rent Payments</strong><br/>Pay your rent from anywhere with your iCard.</p></li>
                                        <li><p><strong>Automate Payment Reminders</strong><br/>One of the many benefits of iCard is the ability to automate rent processing. Setting up automatic payment reminders can help you remember to pay their rent on time.</p></li>
                                      </ul> 
                                </P1>
                            </Space>
                        </Col>
                        <Col lg={{span: 8}} span={AuthLayout}>
                            <Space direction='vertical' style={{width: '100%'}} size={32}>
                                <P1>
                                    <ul>
                                        
                                        <li><p><strong>Identity Verification & Fraud Protection</strong><br/>iCard verifies your identity, tokenizes it and thus protects you from online fraud.</p></li>
                                        <li><p><strong>Keeping Your Data Private From Landlords</strong><br/>iCard cerifies your private information and encrpyts it so landlords or bad actors can&apos;t reuse it.</p></li>
                                        <li><p><strong>Maintence & Service Requests</strong><br/>Send and track maintenance and service requests from iCard.</p></li>
                                      </ul> 
                                </P1>
                            </Space>
                        </Col>
                    </Row>
                </Space>
            </Container>
        </AboutMainWrap>
    );
};

const ActionFormCard = styled(Card)`
  box-shadow: none;
  border: none;
  background: linear-gradient(to top, #f4e1ff, #f4e1ff);
  border-radius: 12px;
  padding: 0px;

  h2 {
    text-align: center;
    //font-size: 28px;
    margin-bottom: 0px;
  }

  h3 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 0px;
  }

  @media (max-width: 768px) {
    padding: 0;
  }
`

export default AboutMain;
